import {
    Avatar,
    Skeleton
} from "@mui/material";
import React from "react";
const TableSkeleton = ({ rows = 3 }) => {
  return (
    <div style={{marginLeft: "30px",marginTop: "45px"}}>
      <p className="Team-total-active-user">
        <Skeleton variant="text" width={150} />
      </p>
      <table className="Team-main-table-container">
        <thead>
          <tr className="table-header-cell">
            <th><Skeleton variant="text" width={40} /></th>
            <th><Skeleton variant="text" width={80} /></th>
            <th><Skeleton variant="text" width={80} /></th>
            <th><Skeleton variant="text" width={80} /></th>
            <th><Skeleton variant="text" width={80} /></th>
            <th><Skeleton variant="text" width={100} /></th>
          </tr>
        </thead>
        <tbody className="tbodyClass01">
          {Array.from(new Array(rows)).map((_, index) => (
            <tr key={index} className="ticket-table-tr">
              <td>
                <Skeleton variant="text" width={60} />
              </td>
              <td>
                <div>
                  <p className="team-table-img">
                    <Skeleton variant="circular">
                      <Avatar sx={{ width: 32, height: 32 }} />
                    </Skeleton>
                    <div>
                      <Skeleton variant="text" width={120} />
                      <Skeleton variant="text" width={180} />
                    </div>
                  </p>
                </div>
              </td>
              <td>
                <Skeleton variant="text" width={150} />
              </td>
              <td>
                <div className="team-table-img">
                  <Skeleton variant="circular">
                    <Avatar sx={{ width: 32, height: 32 }} />
                  </Skeleton>
                  <Skeleton variant="text" width={100} />
                </div>
              </td>
              <td>
                <Skeleton variant="rounded" width={80} height={24} />
              </td>
              <td>
                <Skeleton variant="text" width={160} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSkeleton;
